(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9950],{

/***/ 51751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getSearchResults; },
/* harmony export */   "v": function() { return /* binding */ getSuggestions; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65885);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65599);



/* eslint-disable indent */


var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z();
var authorization = cookies.get('token');
var headers = authorization ? {
  appId: "kritikos-web",
  authorization: "Bearer ".concat(authorization)
} : {
  appId: "kritikos-web"
};
function getSuggestions(_x, _x2) {
  return _getSuggestions.apply(this, arguments);
}

function _getSuggestions() {
  _getSuggestions = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query, collectionTypes) {
    var response;
    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _config__WEBPACK_IMPORTED_MODULE_1__/* .wave.get */ .t.get('/v3/products/search/suggestions', {
              headers: headers,
              params: {
                collectionTypes: collectionTypes,
                term: query
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              error: _context.t0
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _getSuggestions.apply(this, arguments);
}

function getSearchResults(_x3, _x4) {
  return _getSearchResults.apply(this, arguments);
}

function _getSearchResults() {
  _getSearchResults = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(query, collectionTypes) {
    var category,
        pageNumber,
        showBySelection,
        sortMap,
        response,
        _args2 = arguments;
    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            category = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
            pageNumber = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 0;
            showBySelection = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : 'default';
            _context2.prev = 3;
            sortMap = {
              default: 'score|desc',
              offer: 'discount|desc',
              alphabetical: 'name|asc',
              highFirst: 'price|desc',
              lowFirst: 'price|asc',
              kiloPrice: 'unitOfMeasurementFinalPrice|asc'
            };
            _context2.next = 7;
            return _config__WEBPACK_IMPORTED_MODULE_1__/* .wave.get */ .t.get('/v3/products/search', {
              headers: headers,
              params: {
                collectionTypes: collectionTypes,
                term: query,
                category: category,
                pageNumber: pageNumber,
                sort: sortMap[showBySelection]
              }
            });

          case 7:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", {
              error: _context2.t0
            });

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11]]);
  }));
  return _getSearchResults.apply(this, arguments);
}

/***/ }),

/***/ 3805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ PrimaryButton; },
/* harmony export */   "hG": function() { return /* binding */ BrandButton; },
/* harmony export */   "kq": function() { return /* binding */ SecondaryButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88154);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "onClick"],
    _excluded2 = ["children", "onClick"],
    _excluded3 = ["children", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function PrimaryButton(_ref) {
  var children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().primaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function BrandButton(_ref2) {
  var children = _ref2.children,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().brandButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function SecondaryButton(_ref3) {
  var children = _ref3.children,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().secondaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}

/***/ }),

/***/ 27325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82052);
/* harmony import */ var _DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




function DownloadApp(_ref) {
  var appLinks = _ref.appLinks,
      children = _ref.children;

  if (!appLinks || !(appLinks !== null && appLinks !== void 0 && appLinks.androidLink) && !(appLinks !== null && appLinks !== void 0 && appLinks.iosLink)) {
    return null;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: (_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default().body),
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: (_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default().imageContainer),
      children: [(appLinks === null || appLinks === void 0 ? void 0 : appLinks.androidLink) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: (_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default().mobileLinks),
        href: appLinks === null || appLinks === void 0 ? void 0 : appLinks.androidLink,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
          className: (_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default().img),
          loading: "lazy",
          width: "124",
          height: "40",
          src: "/assets/global/play-store.png",
          alt: "google play store"
        })
      }), (appLinks === null || appLinks === void 0 ? void 0 : appLinks.iosLink) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: (_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default().mobileLinks),
        href: appLinks === null || appLinks === void 0 ? void 0 : appLinks.iosLink,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
          className: (_DownloadApp_module_scss__WEBPACK_IMPORTED_MODULE_1___default().img),
          loading: "lazy",
          width: "124",
          height: "40",
          src: "/assets/global/app-store.png",
          alt: "apple app store"
        })
      })]
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (DownloadApp);

/***/ }),

/***/ 31875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/store/cookies.js
var cookies = __webpack_require__(11081);
// EXTERNAL MODULE: ./src/utils/json-storage.js
var json_storage = __webpack_require__(19022);
// EXTERNAL MODULE: ./src/components/Buttons/Buttons.jsx
var Buttons = __webpack_require__(3805);
// EXTERNAL MODULE: ./src/components/CookieConsent/CookieBar.module.scss
var CookieBar_module = __webpack_require__(86910);
var CookieBar_module_default = /*#__PURE__*/__webpack_require__.n(CookieBar_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CookieConsent/CookieBar.jsx








function CookieBar() {
  var _useState = (0,react.useState)(false),
      showBanner = _useState[0],
      setShowBanner = _useState[1];

  function onClickSettings() {
    var cookiesUpdate = {
      necessary: true,
      performance: false,
      ad: false,
      ux: false
    };
    cookies/* default.update */.Z.update(cookiesUpdate);
  }

  function onClickAccept(option) {
    if (option === 'all') {
      var _cookiesUpdate = {
        necessary: true,
        performance: true,
        ad: true,
        ux: true
      };
      cookies/* default.update */.Z.update(_cookiesUpdate);
      setShowBanner(false);
      return;
    }

    var cookiesUpdate = {
      necessary: true,
      performance: false,
      ad: false,
      ux: false
    };
    cookies/* default.update */.Z.update(cookiesUpdate);
    setShowBanner(false);
  }

  (0,react.useEffect)(function () {
    var storage = window.localStorage;
    var privacy = json_storage/* default.get */.ZP.get('Kritikos:privacy', {
      storage: storage
    });
    var privacyNew = json_storage/* default.get */.ZP.get("".concat("kritikos", ":privacy"), {
      storage: storage
    });

    if (!privacy && !privacyNew) {
      setShowBanner(true);
    } else {
      var updatedCookies = privacy || privacyNew;
      cookies/* default.update */.Z.update(updatedCookies);
      json_storage/* default.remove */.ZP.remove('Kritikos:privacy', {
        storage: storage
      });
    }

    var cookies$ = cookies/* default.subscribe */.Z.subscribe();
    return function () {
      return cookies$.unsubscribe();
    };
  }, []);
  return showBanner && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (CookieBar_module_default()).bannerContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CookieBar_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: (CookieBar_module_default()).heading,
        children: "\u0394\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7 cookies \u03BA\u03B1\u03B9 \u03C0\u03B1\u03C1\u03CC\u03BC\u03BF\u03B9\u03C9\u03BD \u03C4\u03B5\u03C7\u03BD\u03BF\u03BB\u03BF\u03B3\u03B9\u03CE\u03BD"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CookieBar_module_default()).textContainer,
        children: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03BF\u03CD\u03BC\u03B5 \u03B5\u03C1\u03B3\u03B1\u03BB\u03B5\u03AF\u03B1 \u03CC\u03C0\u03C9\u03C2 \u03C4\u03B1 cookies \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03BF\u03C5 \u03C0\u03C1\u03BF\u03C3\u03C6\u03AD\u03C1\u03BF\u03C5\u03BC\u03B5 \u03BC\u03AF\u03B1 \u03BA\u03BF\u03C1\u03C5\u03C6\u03B1\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C9\u03C0\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03B7 \u03B5\u03BC\u03C0\u03B5\u03B9\u03C1\u03AF\u03B1, \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03B5 \u03B2\u03BF\u03B7\u03B8\u03AE\u03C3\u03BF\u03C5\u03BC\u03B5 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03B9\u03C2 \u03B5\u03C5\u03BA\u03BF\u03BB\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C0\u03BF\u03C5 \u03C8\u03AC\u03C7\u03BD\u03B5\u03B9\u03C2, \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03C0\u03B9\u03C3\u03BA\u03B5\u03C8\u03B9\u03BC\u03CC\u03C4\u03B7\u03C4\u03AC\u03C2 \u03BC\u03B1\u03C2."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CookieBar_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/cookies",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (CookieBar_module_default()).link,
          onClick: onClickSettings,
          "data-cy": "settings",
          children: "\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CookieBar_module_default()).btnContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SecondaryButton */.kq, {
          "data-cy": "reject-cookies",
          onClick: function onClick() {
            return onClickAccept('necessary');
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "\u0391\u03C0\u03CC\u03C1\u03C1\u03B9\u03C8\u03B7"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* PrimaryButton */.KM, {
          onClick: function onClick() {
            return onClickAccept('all');
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "\u0391\u03C0\u03BF\u03B4\u03BF\u03C7\u03AE"
          })
        })]
      })]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/DownloadApp/DownloadApp.jsx
var DownloadApp = __webpack_require__(27325);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/im/index.esm.js
var im_index_esm = __webpack_require__(53990);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/MainLogo/MainLogo.jsx
var MainLogo = __webpack_require__(10625);
// EXTERNAL MODULE: ./src/components/FooterLinks/FooterLinks.module.scss
var FooterLinks_module = __webpack_require__(36477);
var FooterLinks_module_default = /*#__PURE__*/__webpack_require__.n(FooterLinks_module);
;// CONCATENATED MODULE: ./src/components/FooterLinks/FooterLinks.jsx









var contactInformation = {
  kritikos: [{
    label: '801 11 232425',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(im_index_esm/* ImPhone */.MdO, {
      className: (FooterLinks_module_default()).contactIcon,
      alt: "phone"
    }),
    type: 'phone'
  }, {
    label: '210 55 58 832',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(im_index_esm/* ImPhone */.MdO, {
      className: (FooterLinks_module_default()).contactIcon,
      alt: "phone"
    }),
    type: 'phone'
  }],
  ariadni: [{
    label: '2811100500',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(im_index_esm/* ImPhone */.MdO, {
      className: (FooterLinks_module_default()).contactIcon,
      alt: "phone"
    }),
    type: 'phone'
  }, {
    label: '2810251546',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiFillPrinter */.s4T, {
      className: (FooterLinks_module_default()).contactIcon,
      alt: "printer"
    }),
    type: 'fax'
  }, {
    label: 'info@crmsa.gr',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdEmail */.ixJ, {
      className: (FooterLinks_module_default()).contactIcon,
      alt: "email"
    }),
    type: 'email'
  }, {
    label: 'Ειρήνης και Φιλίας 207-209, Μαλάδες Ηρακλείου, 71500',
    icon: /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiMapPin */.i63, {
      className: (FooterLinks_module_default()).contactIcon,
      alt: "email"
    }),
    type: 'location'
  }]
};
function FooterLinks(_ref) {
  var _footerLinks$footerLi;

  var footerLinks = _ref.footerLinks;
  var links = (footerLinks === null || footerLinks === void 0 ? void 0 : (_footerLinks$footerLi = footerLinks.footerLinks) === null || _footerLinks$footerLi === void 0 ? void 0 : _footerLinks$footerLi.data) || [];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (FooterLinks_module_default()).section,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FooterLinks_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (FooterLinks_module_default()).contactSector,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (FooterLinks_module_default()).logoContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (FooterLinks_module_default()).logo,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(MainLogo/* default */.Z, {})
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (FooterLinks_module_default()).contactNumber,
          children: "\u0395\u03BE\u03C5\u03C0\u03B7\u03C1\u03AD\u03C4\u03B7\u03C3\u03B7 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD"
        }), contactInformation["kritikos"].map(function (n) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: n.type === 'phone' ? /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: (FooterLinks_module_default()).tel,
              href: "tel:".concat(n.label),
              children: [n.icon, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: n.label
              })]
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (FooterLinks_module_default()).tel,
              children: [n.icon, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: n.label
              })]
            })
          }, n.label);
        })]
      }), links.map(function (footerSector) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (FooterLinks_module_default()).sector,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: (FooterLinks_module_default()).header,
            children: footerSector.title
          }), footerSector.fields.footerLink.map(function (footerlink) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: footerlink['footerLink-url'],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: (FooterLinks_module_default()).link,
                children: footerlink['footerLink-title']
              })
            }, footerlink['footerLink-title']);
          })]
        }, footerSector.title);
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var io_index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./src/components/FooterPaymentMethods/FooterPaymentMethods.module.scss
var FooterPaymentMethods_module = __webpack_require__(1677);
var FooterPaymentMethods_module_default = /*#__PURE__*/__webpack_require__.n(FooterPaymentMethods_module);
;// CONCATENATED MODULE: ./src/components/FooterPaymentMethods/FooterPaymentMethods.jsx





function FooterPaymentMethods() {
  var year = dayjs_min_default()().year();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (FooterPaymentMethods_module_default()).section,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (FooterPaymentMethods_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (FooterPaymentMethods_module_default()).credits,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (FooterPaymentMethods_module_default()).text,
          children: ["\xA9 Copyright ".concat(year), /*#__PURE__*/(0,jsx_runtime.jsxs)("strong", {
            className: (FooterPaymentMethods_module_default()).brand,
            children: [" ", "ANEDIK Kritikos"]
          }), ". All Rights Reserved"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (FooterPaymentMethods_module_default()).text,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Made with "
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(io_index_esm/* IoMdHeart */.$g3, {
            className: (FooterPaymentMethods_module_default()).heartML,
            width: "10",
            height: "10",
            alt: "love"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: " by "
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "//thinkdesquared.com/",
            className: (FooterPaymentMethods_module_default()).text,
            target: "_blank",
            rel: "noopener noreferrer",
            children: "Desquared"
          })]
        })]
      }),  true && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (FooterPaymentMethods_module_default()).paymentMethods,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          loading: "lazy",
          className: (FooterPaymentMethods_module_default()).nbg,
          width: "62",
          height: "32",
          src: "/assets/global/nbg.png",
          alt: "nbg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (FooterPaymentMethods_module_default()).divider
        }), ["amex","visa","mastercard","maestro"].map(function (card) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            loading: "lazy",
            className: (FooterPaymentMethods_module_default()).paymentMethodImg,
            width: "32",
            height: "32",
            src: "/assets/global/".concat(card, ".png"),
            alt: card
          }, card);
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./src/components/Footer/Footer.module.scss
var Footer_module = __webpack_require__(84024);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./src/components/Footer/Newsletter.module.scss
var Newsletter_module = __webpack_require__(7236);
var Newsletter_module_default = /*#__PURE__*/__webpack_require__.n(Newsletter_module);
;// CONCATENATED MODULE: ./src/components/Footer/Newsletter.jsx







var GenericModalV2 = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3253), __webpack_require__.e(1501)]).then(__webpack_require__.bind(__webpack_require__, 29962));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(29962)];
    }
  }
});
function Newsletter() {
  var _useState = (0,react.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var success = "\u0395\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF Newsletter \u03C4\u03C9\u03BD Supermarket ".concat("ΚΡΗΤΙΚΟΣ");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      className: (Newsletter_module_default()).newsletter,
      action: "//www.contactpigeon.com/apps/en/stem/subscribe.html/",
      method: "post",
      name: "form_sf_8874",
      onSubmit: function onSubmit() {
        return setOpenModal(true);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        type: "hidden",
        value: "8874",
        name: "gm_pid"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: (Newsletter_module_default())["newsletter-input"],
        type: "email",
        id: "sfemail",
        name: "sfemail",
        placeholder: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03C4\u03BF Newsletter",
        required: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        type: "submit",
        name: "regme",
        className: (Newsletter_module_default()).newsletterButton,
        "aria-label": "newsletter",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Newsletter_module_default()).iconBorder,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaTelegramPlane */.AGi, {
            className: (Newsletter_module_default()).iconNewsletter
          })
        })
      })]
    }), openModal && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModalV2, {
        mainText: success,
        isOpen: openModal,
        modalLabel: "Info modal"
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Footer/Social.module.scss
var Social_module = __webpack_require__(60564);
var Social_module_default = /*#__PURE__*/__webpack_require__.n(Social_module);
;// CONCATENATED MODULE: ./src/components/Footer/Social.jsx






function Social(_ref) {
  var _socials$, _socials$2;

  var socials = _ref.socials;
  var title = socials === null || socials === void 0 ? void 0 : (_socials$ = socials[0]) === null || _socials$ === void 0 ? void 0 : _socials$.title;
  var links = socials === null || socials === void 0 ? void 0 : (_socials$2 = socials[0]) === null || _socials$2 === void 0 ? void 0 : _socials$2.fields;

  if (!links) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (Social_module_default()).socialHeader,
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Social_module_default()).social,
      children: [links.facebookLink && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: links.facebookLink,
        "aria-label": "\u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF facebook",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Social_module_default()).socialItem,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaFacebookF */.tBk, {
            className: (Social_module_default()).socialIcon
          })
        })
      }), links.twitterLink && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: links.twitterLink,
        "aria-label": "\u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF twitter",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Social_module_default()).socialItem,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaTwitter */.fWC, {
            className: (Social_module_default()).socialIcon
          })
        })
      }), links.instagramLink && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: links.instagramLink,
        "aria-label": "\u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF instagram",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Social_module_default()).socialItem,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaInstagram */.Zf_, {
            className: (Social_module_default()).socialIcon
          })
        })
      }), links.youtubeLink && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: links.youtubeLink,
        "aria-label": "\u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B1\u03C2 \u03C3\u03C4\u03BF youtube",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Social_module_default()).socialItem,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(im_index_esm/* ImYoutube */.Rne, {
            className: (Social_module_default()).socialIcon
          })
        })
      })]
    })]
  });
}

/* harmony default export */ var Footer_Social = (Social);
;// CONCATENATED MODULE: ./src/components/Footer/Footer.jsx










function Footer(_ref) {
  var _footerLinks$socials, _footerLinks$appLinks, _footerLinks$appLinks2, _footerLinks$appLinks3;

  var footerLinks = _ref.footerLinks,
      noCookies = _ref.noCookies;
  var socials = (footerLinks === null || footerLinks === void 0 ? void 0 : (_footerLinks$socials = footerLinks.socials) === null || _footerLinks$socials === void 0 ? void 0 : _footerLinks$socials.data) || [];
  var appLinks = footerLinks === null || footerLinks === void 0 ? void 0 : (_footerLinks$appLinks = footerLinks.appLinks) === null || _footerLinks$appLinks === void 0 ? void 0 : (_footerLinks$appLinks2 = _footerLinks$appLinks.data) === null || _footerLinks$appLinks2 === void 0 ? void 0 : (_footerLinks$appLinks3 = _footerLinks$appLinks2[0]) === null || _footerLinks$appLinks3 === void 0 ? void 0 : _footerLinks$appLinks3.fields;
  var footerLinksMemo = (0,react.useMemo)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(FooterLinks, {
      footerLinks: footerLinks
    });
  }, [footerLinks]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    className: (Footer_module_default()).container,
    children: [footerLinksMemo, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Footer_module_default()).appSector,
      children: [ true && /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadApp/* default */.Z, {
        appLinks: appLinks,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (Footer_module_default()).downloadAppTitle,
          children: "\u039A\u0391\u03A4\u0395\u0392\u0391\u03A3\u0395 \u03A4\u039F APP"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_Social, {
        socials: socials
      }),  true && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (Footer_module_default()).socialHeader,
          children: "\u039C\u0391\u0398\u0395 \u03A0\u03A1\u03A9\u03A4\u039F\u03A3 \u03A4\u0391 \u039D\u0395\u0391 \u039C\u0391\u03A3"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (Footer_module_default()).flexCenter,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Newsletter, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "newsletter",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FooterPaymentMethods, {})
    }), !noCookies && /*#__PURE__*/(0,jsx_runtime.jsx)(CookieBar, {})]
  });
}

/***/ }),

/***/ 3266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./src/api/wave/users.js
var users = __webpack_require__(71231);
// EXTERNAL MODULE: ./src/store/addressModal.js
var addressModal = __webpack_require__(49578);
// EXTERNAL MODULE: ./src/store/authModalShow.js
var authModalShow = __webpack_require__(24001);
// EXTERNAL MODULE: ./src/store/guestUser.js
var store_guestUser = __webpack_require__(42604);
// EXTERNAL MODULE: ./src/store/user.js
var user = __webpack_require__(73471);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/size.js
var size = __webpack_require__(84238);
var size_default = /*#__PURE__*/__webpack_require__.n(size);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./src/store/cart.js
var cart = __webpack_require__(88362);
// EXTERNAL MODULE: ./src/components/HeaderCart/HeaderCart.module.scss
var HeaderCart_module = __webpack_require__(993);
var HeaderCart_module_default = /*#__PURE__*/__webpack_require__.n(HeaderCart_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/HeaderCart/HeaderCart.jsx










var Cart = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2013), __webpack_require__.e(3253), __webpack_require__.e(3340)]).then(__webpack_require__.bind(__webpack_require__, 83340));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(83340)];
    }
  }
});
var SwitchServiceModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3253), __webpack_require__.e(6043)]).then(__webpack_require__.bind(__webpack_require__, 96043));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(96043)];
    }
  }
});
function HeaderCart(_ref) {
  var isFullPageCart = _ref.isFullPageCart;

  var _useState = (0,react.useState)(0),
      numProductsInCart = _useState[0],
      setNumProductsInCart = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isCartVisible = _useState2[0],
      setIsCartVisible = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isModalSwitchOpen = _useState3[0],
      setIsModalSwitchOpen = _useState3[1];

  (0,react.useEffect)(function () {
    var productsInCart$ = cart/* productsQuantities.subscribe */.UU.subscribe(function (products) {
      var numOfProducts = size_default()(products);
      setNumProductsInCart(numOfProducts);
    });
    var cartIsVisible$ = cart/* default.getIsVisble$ */.ZP.getIsVisble$().subscribe(function (_cartVisible) {
      setIsCartVisible(_cartVisible);
    });
    var isCartModalOpen$ = cart/* default.getIsModalOpen$ */.ZP.getIsModalOpen$().subscribe(setIsModalSwitchOpen);
    return function () {
      productsInCart$.unsubscribe();
      cartIsVisible$.unsubscribe();
      isCartModalOpen$.unsubscribe();
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (HeaderCart_module_default()).cartHeaderContainer,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: classnames_default()((HeaderCart_module_default()).cart, (0,defineProperty/* default */.Z)({}, (HeaderCart_module_default()).isFullPageCart, isFullPageCart)),
      onClick: function onClick() {
        if (isFullPageCart) return;
        cart/* default.toggleVisibility */.ZP.toggleVisibility();
      },
      "data-cy": "header-show-cart",
      "aria-label": "my cart",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (HeaderCart_module_default()).cartIconContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* IoMdCart */.kdn, {
          className: (HeaderCart_module_default()).icon,
          alt: "Cart"
        }), numProductsInCart !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (HeaderCart_module_default()).numProductsText,
          children: numProductsInCart
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (HeaderCart_module_default()).text,
        children: "\u03A4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9 \u03BC\u03BF\u03C5"
      })]
    }), isCartVisible && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (HeaderCart_module_default()).cartContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Cart, {})
      })
    }), isModalSwitchOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SwitchServiceModal, {
        isOpen: isModalSwitchOpen
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./src/components/HeaderUser/HeaderUser.module.scss
var HeaderUser_module = __webpack_require__(6581);
var HeaderUser_module_default = /*#__PURE__*/__webpack_require__.n(HeaderUser_module);
;// CONCATENATED MODULE: ./src/components/HeaderUser/HeaderUser.jsx






function HeaderUser(_ref) {
  var user = _ref.user,
      guestUser = _ref.guestUser;

  if (guestUser !== null && guestUser !== void 0 && guestUser.email) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/guest",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: (HeaderUser_module_default()).user,
        "data-cy": "guest-user",
        "aria-label": "go to guest-user page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUserCircle */.m3W, {
          className: (HeaderUser_module_default()).iconUser,
          alt: "go to guest-user page"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (HeaderUser_module_default()).text,
          children: "\u0395\u03C0\u03B9\u03C3\u03BA\u03AD\u03C0\u03C4\u03B7\u03C2"
        })]
      })
    });
  }

  if (!(user !== null && user !== void 0 && user._id)) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/login",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        className: (HeaderUser_module_default()).user,
        "data-cy": "user",
        "aria-label": "go to log in page",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUserCircle */.m3W, {
          className: (HeaderUser_module_default()).icon,
          alt: "go to log in page"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (HeaderUser_module_default()).text,
          children: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7/\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE"
        })]
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: "/user",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      className: (HeaderUser_module_default()).user,
      "data-cy": "user",
      "aria-label": "go to user page",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUserCircle */.m3W, {
        className: (HeaderUser_module_default()).iconUser,
        alt: "go to user page"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (HeaderUser_module_default()).nameText,
        children: user.firstName
      })]
    })
  });
}

/* harmony default export */ var HeaderUser_HeaderUser = (HeaderUser);
// EXTERNAL MODULE: ./src/components/MainLogo/MainLogo.jsx
var MainLogo = __webpack_require__(10625);
// EXTERNAL MODULE: ./node_modules/react-debounce-input/lib/index.js
var lib = __webpack_require__(775);
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var go_index_esm = __webpack_require__(66653);
// EXTERNAL MODULE: ./src/api/Search.js
var Search = __webpack_require__(51751);
// EXTERNAL MODULE: ./src/store/deliveryMode.js
var deliveryMode = __webpack_require__(34525);
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/store/productsSearch.js
var productsSearch = __webpack_require__(68960);
// EXTERNAL MODULE: ./src/utils/objectManipulation.js
var objectManipulation = __webpack_require__(18745);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./src/components/SuggestedSearchProduct/SuggestedSearchProduct.module.scss
var SuggestedSearchProduct_module = __webpack_require__(25387);
var SuggestedSearchProduct_module_default = /*#__PURE__*/__webpack_require__.n(SuggestedSearchProduct_module);
;// CONCATENATED MODULE: ./src/components/SuggestedSearchProduct/SuggestedSearchProduct.jsx





function SuggestedSearchProduct(_ref) {
  var product = _ref.product;
  if (!product) return null;
  var base = product.slug.substring(0, product.slug.indexOf('/'));
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: "/".concat(base).concat(product.slug.replace(base, '')),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SuggestedSearchProduct_module_default()).link,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (SuggestedSearchProduct_module_default()).img,
        src: "".concat(product.image.baseUrl).concat(product.image.primary),
        alt: product.title
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (SuggestedSearchProduct_module_default()).resultTitle,
          children: product.title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SuggestedSearchProduct_module_default()).productTextsContainer,
          children: [product.webSticker && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (SuggestedSearchProduct_module_default()).webStickerContainer,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (SuggestedSearchProduct_module_default()).badge,
              children: product.webSticker
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (SuggestedSearchProduct_module_default()).productSubtitle,
            children: product.description
          })]
        })]
      })]
    })
  }, product.id);
}

/* harmony default export */ var SuggestedSearchProduct_SuggestedSearchProduct = (SuggestedSearchProduct);
// EXTERNAL MODULE: ./src/components/SuggestedSearchResults/SuggestedSearchResults.module.scss
var SuggestedSearchResults_module = __webpack_require__(60715);
var SuggestedSearchResults_module_default = /*#__PURE__*/__webpack_require__.n(SuggestedSearchResults_module);
;// CONCATENATED MODULE: ./src/components/SuggestedSearchResults/SuggestedSearchResults.jsx









var suggestionsText = {
  el: {
    searchResults: 'Προτάσεις αναζήτησης',
    suggestedProducts: 'Προϊόντα για εσένα',
    catalogueProducts: 'Προϊόντα καταλόγου',
    in: 'σε',
    all: 'όλες',
    categories: 'τις κατηγορίες'
  }
};
/* harmony default export */ var SuggestedSearchResults = (function (_ref) {
  var query = _ref.query,
      suggestions = _ref.suggestions;
  if (query.length < 3) return null;
  return !isEmpty_default()(suggestions.categories) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (SuggestedSearchResults_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (SuggestedSearchResults_module_default()).title,
      children: suggestionsText.el.searchResults
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: "/search?product=".concat(query),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (SuggestedSearchResults_module_default()).link,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (SuggestedSearchResults_module_default()).resultTitle,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(go_index_esm/* GoSearch */.a4h, {
            className: (SuggestedSearchResults_module_default()).icon,
            alt: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7",
            "aria-hidden": "true"
          }), query]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (SuggestedSearchResults_module_default()).resultSubtitle,
          children: ["- ", suggestionsText.el.in, " ", suggestionsText.el.all, " ", suggestionsText.el.categories]
        })]
      })
    }), suggestions.categories.map(function (suggestion) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/search?category=".concat(suggestion.category._id, "&product=").concat(suggestion.term),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SuggestedSearchResults_module_default()).link,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (SuggestedSearchResults_module_default()).resultTitle,
            children: [suggestion.previouslySearched ? /*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiHistoryLine */.WNt, {
              className: (SuggestedSearchResults_module_default()).icon,
              alt: "history",
              "aria-hidden": "true"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(go_index_esm/* GoSearch */.a4h, {
              className: (SuggestedSearchResults_module_default()).icon,
              alt: "search",
              "aria-hidden": "true"
            }), suggestion.term]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (SuggestedSearchResults_module_default()).resultSubtitle,
            children: ["- ", suggestionsText.el.in, " ", suggestion.category.name]
          })]
        })
      }, suggestion.category._id);
    }), !isEmpty_default()(suggestions.suggestedProducts) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (SuggestedSearchResults_module_default()).title,
        children: suggestionsText.el.suggestedProducts
      }), suggestions.suggestedProducts.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SuggestedSearchProduct_SuggestedSearchProduct, {
          product: product
        });
      })]
    }), !isEmpty_default()(suggestions.catalogProducts) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (SuggestedSearchResults_module_default()).title,
        children: suggestionsText.el.catalogueProducts
      }), suggestions.catalogProducts.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SuggestedSearchProduct_SuggestedSearchProduct, {
          product: product
        });
      })]
    })]
  });
});
// EXTERNAL MODULE: ./src/components/SearchBar/SearchBar.module.scss
var SearchBar_module = __webpack_require__(50790);
var SearchBar_module_default = /*#__PURE__*/__webpack_require__.n(SearchBar_module);
;// CONCATENATED MODULE: ./src/components/SearchBar/SearchBar.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var OrderAlertModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3253), __webpack_require__.e(6452)]).then(__webpack_require__.bind(__webpack_require__, 26452));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26452)];
    }
  }
});
function SearchBar() {
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _useState2 = (0,react.useState)(''),
      query = _useState2[0],
      setQuery = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      hideSuggestions = _useState3[0],
      setHideSuggestions = _useState3[1];

  var _useState4 = (0,react.useState)(["900"]),
      collectionTypes = _useState4[0],
      setCollectionTypes = _useState4[1];

  var _useState5 = (0,react.useState)({}),
      suggestions = _useState5[0],
      setSuggestions = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      suggestionsFlag = _useState6[0],
      setSuggestionsFlag = _useState6[1];

  (0,react.useEffect)(function () {
    var deliveryMode$ = deliveryMode/* default.subscribe */.Z.subscribe(function (mode) {
      var _collectionTypes = deliveryMode/* default.getCollectionAsNumber */.Z.getCollectionAsNumber(mode);

      setCollectionTypes(_collectionTypes);
    });
    return function () {
      deliveryMode$.unsubscribe();
    };
  }, []);
  (0,react.useEffect)(function () {
    var query$ = productsSearch/* default.query */.Z.query(setQuery);
    return function () {
      query$.unsubscribe();
    };
  }, []);
  (0,react.useEffect)(function () {
    var _router$query;

    if (!router.isReady) return;

    var searchTerm = _objectSpread({}, (0,objectManipulation/* getValidObject */.t9)('product', router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.product));

    productsSearch/* default.updateQuery */.Z.updateQuery((searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.product) || '');
  }, [router.isReady]);
  (0,react.useEffect)(function () {
    function fetchSuggestions() {
      return _fetchSuggestions.apply(this, arguments);
    }

    function _fetchSuggestions() {
      _fetchSuggestions = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _suggestions;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,Search/* getSuggestions */.v)(query, collectionTypes);

              case 2:
                _suggestions = _context.sent;
                setSuggestions(_suggestions);
                setSuggestionsFlag(false);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchSuggestions.apply(this, arguments);
    }

    if (suggestionsFlag && query.length > 2) {
      fetchSuggestions();
    }
  }, [query, collectionTypes]);

  function updateURL(routerAction) {
    var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : query;

    var params = _objectSpread({
      product: product
    }, (0,objectManipulation/* getValidObject */.t9)('sortBy', null));

    router[routerAction]({
      pathname: '/search',
      query: params
    }, undefined, {
      shallow: false
    });
  }

  function onChangeQuery(_ref) {
    var value = _ref.target.value;
    setQuery(value);
    setHideSuggestions(false);

    if (value.length > 2) {
      productsSearch/* default.updateQuery */.Z.updateQuery(value);
      (0,analytics/* viewSearchResults */.GW)(value);
      setSuggestionsFlag(true);
    }
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!query || query.length === 0) {
      return;
    }

    loader/* default.addEvent */.Z.addEvent('ROUTE_CHANGE');
    updateURL('push');
  }

  function onBlurSearchBar() {
    setTimeout(function () {
      setHideSuggestions(true);
      setSuggestionsFlag(false);
    }, 300);
  }

  function onFocusSearchBar() {
    setSuggestionsFlag(true);
    setHideSuggestions(false);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      className: (SearchBar_module_default()).container,
      onSubmit: onSubmit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib.DebounceInput, {
        minLength: 1,
        debounceTimeout: 300,
        className: (SearchBar_module_default()).input,
        onBlur: onBlurSearchBar,
        onFocus: onFocusSearchBar,
        value: query,
        onChange: onChangeQuery,
        placeholder: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1",
        "data-cy": "search-bar"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: (SearchBar_module_default()).submit,
        "aria-label": "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(go_index_esm/* GoSearch */.a4h, {
          className: (SearchBar_module_default()).icon,
          alt: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7",
          "aria-hidden": "true"
        })
      }), query.length > 2 && !hideSuggestions && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
        fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SuggestedSearchResults, {
          query: query,
          suggestions: suggestions
        })
      })]
    }), isModalOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderAlertModal, {
        alertText: "\u039F \u03CC\u03C1\u03BF\u03C2 \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC ".concat(productsSearch/* MIN_QUERY_LENGTH */.x - 1, " \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03B1."),
        modalLabel: "\u039C\u03B7 \u03B1\u03C0\u03BF\u03B4\u03B5\u03BA\u03C4\u03CC\u03C2 \u03CC\u03C1\u03BF\u03C2 \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2",
        isModalOpen: isModalOpen,
        callback: function callback() {
          return setIsModalOpen(false);
        }
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/ShopsLink/ShopsLink.module.scss
var ShopsLink_module = __webpack_require__(17659);
var ShopsLink_module_default = /*#__PURE__*/__webpack_require__.n(ShopsLink_module);
;// CONCATENATED MODULE: ./src/components/ShopsLink/ShopsLink.jsx





function ShopsLink() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: "/stores",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
      className: (ShopsLink_module_default()).container,
      "aria-label": "find shop",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdLocationPin */.vcr, {
        className: (ShopsLink_module_default()).icon,
        alt: "pin"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (ShopsLink_module_default()).text,
        children: "\u0392\u03C1\u03B5\u03C2 \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03AC \u03C3\u03BF\u03C5"
      })]
    })
  });
}
// EXTERNAL MODULE: ./src/components/SquareButton/ButtonToTop.module.scss
var ButtonToTop_module = __webpack_require__(37973);
var ButtonToTop_module_default = /*#__PURE__*/__webpack_require__.n(ButtonToTop_module);
;// CONCATENATED MODULE: ./src/components/SquareButton/ButtonToTop.jsx







function ButtonToTop() {
  var _useState = (0,react.useState)(false),
      isButtonVisible = _useState[0],
      setIsButtonVisible = _useState[1];

  function onClickBackToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  function handleScroll() {
    var distanceFromTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    if (distanceFromTop > 220) {
      setIsButtonVisible(true);
    } else {
      setIsButtonVisible(false);
    }
  }

  (0,react.useEffect)(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    onClick: onClickBackToTop,
    className: classnames_default()((ButtonToTop_module_default()).button, (0,defineProperty/* default */.Z)({}, (ButtonToTop_module_default()).hideButton, !isButtonVisible)),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdKeyboardArrowUp */.rWj, {
      className: (ButtonToTop_module_default()).icon,
      alt: "\u03BA\u03BF\u03C5\u03BC\u03C0\u03AF scroll to the top"
    })
  });
}

/* harmony default export */ var SquareButton_ButtonToTop = (ButtonToTop);
// EXTERNAL MODULE: ./src/components/Header/Hamburger/Hamburger.module.scss
var Hamburger_module = __webpack_require__(99116);
var Hamburger_module_default = /*#__PURE__*/__webpack_require__.n(Hamburger_module);
;// CONCATENATED MODULE: ./src/components/Header/Hamburger/Hamburger.jsx



function Hamburger(_ref) {
  var hamburgerClick = _ref.hamburgerClick;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    type: "button",
    className: (Hamburger_module_default()).navHamburger,
    onClick: function onClick() {
      hamburgerClick();
    },
    "aria-label": "hamburger menu",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (Hamburger_module_default()).line
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (Hamburger_module_default()).line
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (Hamburger_module_default()).line
    })]
  });
}
// EXTERNAL MODULE: ./src/components/Header/Header.module.scss
var Header_module = __webpack_require__(55125);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/Header/Header.jsx




function Header_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Header_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Header_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Header_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var ConfirmationModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3253), __webpack_require__.e(3939)]).then(__webpack_require__.bind(__webpack_require__, 93939));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(93939)];
    }
  }
});
var AddressViewModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(260), __webpack_require__.e(3253), __webpack_require__.e(9979), __webpack_require__.e(5642), __webpack_require__.e(7536), __webpack_require__.e(3988), __webpack_require__.e(2998), __webpack_require__.e(1538)]).then(__webpack_require__.bind(__webpack_require__, 8221));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8221)];
    }
  }
});
var MenuModal = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(260), __webpack_require__.e(3253), __webpack_require__.e(9030)]).then(__webpack_require__.bind(__webpack_require__, 59030));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59030)];
    }
  }
});
function Header(_ref) {
  var navigation = _ref.navigation,
      _ref$isFullPageCart = _ref.isFullPageCart,
      isFullPageCart = _ref$isFullPageCart === void 0 ? false : _ref$isFullPageCart;

  var _useState = (0,react.useState)(''),
      currentUser = _useState[0],
      setCurrentUser = _useState[1];

  var _useState2 = (0,react.useState)({}),
      guestUser = _useState2[0],
      setGuestUser = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showMenu = _useState3[0],
      setShowMenu = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      noUserFavoritesModal = _useState4[0],
      setNoUserFavoritesModal = _useState4[1];

  var _useState5 = (0,react.useState)('close'),
      openAddressModal = _useState5[0],
      setOpenAddressModal = _useState5[1];

  var cookies = new es6/* default */.Z();

  function showMobileMenu() {
    setShowMenu(!showMenu);
  }

  function closeAddressModal() {
    addressModal/* IsAddressModalOpen.update */.N.update('close');
  }

  function addAddress(_x) {
    return _addAddress.apply(this, arguments);
  }

  function _addAddress() {
    _addAddress = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(newAddress) {
      var addressToCreate, token, response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,analytics/* addToAnalytics */.z2)('addAddres', undefined, [['option', 'submit']]);
              addressToCreate = {
                address: [Header_objectSpread({}, newAddress)]
              };
              token = cookies.get('token');
              _context.next = 5;
              return (0,users/* createAddressUser */.hE)(token, addressToCreate);

            case 5:
              response = _context.sent;

              if (!(typeof response === 'string')) {
                _context.next = 9;
                break;
              }

              closeAddressModal();
              return _context.abrupt("return");

            case 9:
              user/* default.addAddress */.Z.addAddress(response === null || response === void 0 ? void 0 : response.address);
              closeAddressModal();
              router_default().push('/cart', '/cart');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _addAddress.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    var user$ = user/* default.subscribe */.Z.subscribe(setCurrentUser);
    var addressModal$ = addressModal/* IsAddressModalOpen.subscribe */.N.subscribe(setOpenAddressModal);
    var authFavoriteModal$ = authModalShow/* AuthFavoriteModal.subscribe */.u.subscribe(setNoUserFavoritesModal);
    var guestUser$ = store_guestUser/* default.subscribe */.Z.subscribe(setGuestUser);
    return function () {
      user$.unsubscribe();
      authFavoriteModal$.unsubscribe();
      addressModal$.unsubscribe();
      guestUser$.unsubscribe();
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      className: (Header_module_default()).container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        className: (Header_module_default()).leftContainer,
        title: "Home",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (Header_module_default()).logoContainer,
            "data-cy": "logo-home",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(MainLogo/* default */.Z, {})
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        className: (Header_module_default()).subContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: (Header_module_default()).middleContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShopsLink, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBar, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: (Header_module_default()).rightContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderUser_HeaderUser, {
            user: currentUser,
            guestUser: guestUser
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderCart, {
            isFullPageCart: isFullPageCart
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Hamburger, {
            hamburgerClick: showMobileMenu
          })]
        })]
      })]
    }), noUserFavoritesModal && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmationModal, {
        onClickBack: function onClickBack() {
          authModalShow/* AuthFavoriteModal.update */.u.update(false);
          router_default().push('/login', '/login');
        },
        onClickContinue: function onClickContinue() {
          authModalShow/* AuthFavoriteModal.update */.u.update(false);
          router_default().push('/register', '/register');
        },
        backBtnText: "\u0395\u03AF\u03C3\u03BF\u03B4\u03BF\u03C2",
        continueBtnText: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE",
        modalLabel: "Action modal",
        modalClose: function modalClose() {
          return authModalShow/* AuthFavoriteModal.update */.u.update(false);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (Header_module_default()).modalContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (Header_module_default()).modalIcon,
            src: "/assets/global/favorite-cart.png",
            alt: "cart with a heart"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (Header_module_default()).modalText,
            children: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03AE \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03BA\u03AC\u03C0\u03BF\u03B9\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03C3\u03C4\u03B1 \u03B1\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1 \u03C3\u03B1\u03C2."
          })]
        })
      })
    }), openAddressModal === 'open' && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AddressViewModal, {
        isOpen: openAddressModal === 'open',
        setIsOpen: closeAddressModal,
        onSubmitCB: addAddress
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: (Header_module_default()).middleContainerSmallScreen,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ShopsLink, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchBar, {})]
    }), showMenu && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {}),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MenuModal, {
        isOpen: showMenu,
        setIsOpen: setShowMenu,
        navigation: navigation,
        onClickMenuOptions: showMobileMenu
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SquareButton_ButtonToTop, {})]
  });
}

/***/ }),

/***/ 10625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainLogo; }
/* harmony export */ });
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61680);
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function MainLogo() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
    className: (_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().logo),
    width: "160",
    height: "56",
    src: "/assets/".concat("kritikos", "/logo.svg"),
    alt: "".concat("kritikos", " logo"),
    "data-cy": "logo"
  });
}

/***/ }),

/***/ 86894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Navigation; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23276);
/* harmony import */ var _Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







function isSubnavValid(subnav) {
  if (!subnav || !subnav.length) return false;
  return !subnav.some(function (v) {
    return !v['subnav-title'] || !v['subnav-url'];
  });
}

function Navigation(_ref) {
  var _ref$navigation = _ref.navigation,
      navigation = _ref$navigation === void 0 ? [] : _ref$navigation;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("section", {
    className: (_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("nav", {
      className: (_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().navbar),
      children: navigation.map(function (navbar) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().relative),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: navbar.fields.url,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().submenu), isSubnavValid(navbar.fields.subnav))),
              children: navbar.title
            })
          }), isSubnavValid(navbar.fields.subnav) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: (_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().submenuDropdown),
            "data-cy": "submenu",
            children: navbar.fields.subnav.map(function (subnav) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: subnav['subnav-url'],
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
                  "data-cy": subnav['subnav-title'],
                  className: (_Navigation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subnavLink),
                  children: subnav['subnav-title'] || ''
                })
              }, subnav['subnav-title']);
            })
          })]
        }, navbar.uuid);
      })
    })
  });
}

/***/ }),

/***/ 49578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ IsAddressModalOpen; }
/* harmony export */ });
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20090);

var isAddressModalOpenSubject = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var IsAddressModalOpen = {
  update: function update(value) {
    isAddressModalOpenSubject.next(value);
  },
  subscribe: function subscribe(setState) {
    return isAddressModalOpenSubject.subscribe(setState);
  },
  getValue: function getValue() {
    return isAddressModalOpenSubject.value;
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  IsAddressModalOpen: IsAddressModalOpen
});

/***/ }),

/***/ 24001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* binding */ AuthVerificationToken; },
/* harmony export */   "Qb": function() { return /* binding */ AuthModal; },
/* harmony export */   "Rt": function() { return /* binding */ AuthModalView; },
/* harmony export */   "u": function() { return /* binding */ AuthFavoriteModal; }
/* harmony export */ });
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20090);

var subjectShowAuthModal = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var subjectShowFavoriteAuthModal = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(false);
var subjectAuthModalView = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X('login');
var subjectAuthVerificationToken = new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X('');
var meta = {
  fetched: false,
  updatedAt: new Date()
};

function onFetch() {
  Object.assign(meta, {
    fetched: true,
    updatedAt: new Date()
  });
}

var AuthModal = {
  update: function update(authModal) {
    subjectShowAuthModal.next(authModal);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectShowAuthModal.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectShowAuthModal.value;
  }
};
var AuthModalView = {
  update: function update(authModalView) {
    subjectAuthModalView.next(authModalView);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectAuthModalView.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectAuthModalView.value;
  }
};
var AuthFavoriteModal = {
  update: function update(authModal) {
    subjectShowFavoriteAuthModal.next(authModal);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectShowFavoriteAuthModal.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectShowFavoriteAuthModal.value;
  }
};
var AuthVerificationToken = {
  update: function update(verificationToken) {
    subjectAuthVerificationToken.next(verificationToken);
    onFetch();
  },
  subscribe: function subscribe(setState) {
    return subjectAuthVerificationToken.subscribe(setState);
  },
  getValue: function getValue() {
    return subjectAuthVerificationToken.value;
  }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  AuthModal: AuthModal,
  AuthModalView: AuthModalView,
  AuthFavoriteModal: AuthFavoriteModal,
  AuthVerificationToken: AuthVerificationToken
});

/***/ }),

/***/ 42604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20090);
/* harmony import */ var _utils_json_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19022);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var initialState = {
  email: '',
  contactPhone: '',
  city: '',
  nameAtBell: '',
  floor: '',
  postalCode: '',
  street: '',
  streetNo: ''
};
var GuestUserStore = {
  subject: null,
  _lazyInit: function _lazyInit() {
    if (GuestUserStore.subject) return GuestUserStore.subject;
    var storage = window.sessionStorage;
    var guestUser = _utils_json_storage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get('guestUser', {
      storage: storage
    });
    GuestUserStore.subject = new rxjs__WEBPACK_IMPORTED_MODULE_2__/* .BehaviorSubject */ .X(guestUser);
    return GuestUserStore.subject;
  },
  update: function update(guest) {
    var guestNext = _objectSpread(_objectSpread({}, GuestUserStore.getValue()), guest);

    var guestUser = GuestUserStore._lazyInit();

    guestUser.next(guestNext);
    var storage = window.sessionStorage;
    _utils_json_storage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .ZP.set('guestUser', guestNext, {
      storage: storage
    });
  },
  subscribe: function subscribe(setState) {
    var guestUser = GuestUserStore._lazyInit();

    return guestUser.subscribe(setState);
  },
  getValue: function getValue() {
    var guestUser = GuestUserStore._lazyInit();

    return guestUser.value;
  },
  setInitUser: function setInitUser() {
    GuestUserStore.update(initialState);
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (GuestUserStore);

/***/ }),

/***/ 68960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ MIN_QUERY_LENGTH; }
/* harmony export */ });
/* harmony import */ var greek_utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9218);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20090);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35124);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66008);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55709);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96381);
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56449);
/* harmony import */ var _deliveryMode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34525);
/* harmony import */ var _productsCollection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67713);






var MIN_QUERY_LENGTH = 3;
var query$ = new rxjs__WEBPACK_IMPORTED_MODULE_4__/* .BehaviorSubject */ .X('');
var search$ = query$.pipe((0,rxjs_operators__WEBPACK_IMPORTED_MODULE_5__/* .filter */ .h)(function (v) {
  return v.length >= MIN_QUERY_LENGTH;
}), (0,rxjs_operators__WEBPACK_IMPORTED_MODULE_6__/* .map */ .U)(greek_utilities__WEBPACK_IMPORTED_MODULE_0__/* .getGreeklish */ .MW), (0,rxjs_operators__WEBPACK_IMPORTED_MODULE_7__/* .switchMap */ .w)(function (val) {
  var service = _deliveryMode__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getValue */ .Z.getValue();
  var collectionType = _deliveryMode__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCollectionAsNumber */ .Z.getCollectionAsNumber(service);
  var products = _productsCollection__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getProductsForCollections */ .Z.getProductsForCollections(collectionType);
  var searchResults = products === null || products === void 0 ? void 0 : products.filter(function (product) {
    var _product$searchTerms;

    var terms = (product === null || product === void 0 ? void 0 : (_product$searchTerms = product.searchTerms) === null || _product$searchTerms === void 0 ? void 0 : _product$searchTerms.reduced) || '';
    return val.split(' ').every(function (v) {
      return terms.includes(v);
    });
  });
  var exactQueryMatch = searchResults.filter(function (product) {
    var _product$searchTerms2;

    var terms = (product === null || product === void 0 ? void 0 : (_product$searchTerms2 = product.searchTerms) === null || _product$searchTerms2 === void 0 ? void 0 : _product$searchTerms2.reduced) || '';
    var queryOnTerms = terms.split(' ').filter(function (term) {
      return term.startsWith(val);
    });
    return !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(queryOnTerms);
  });

  if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_1___default()(exactQueryMatch)) {
    return [searchResults];
  }

  return [exactQueryMatch];
}));
var ProductsSearchStore = {
  updateQuery: function updateQuery(query) {
    query$.next(query);
  },
  query: function query(setState) {
    return query$.subscribe(setState);
  },
  getValue: function getValue() {
    return query$.value;
  },
  searchedProducts$: (0,rxjs__WEBPACK_IMPORTED_MODULE_8__/* .concat */ .z)(_productsCollection__WEBPACK_IMPORTED_MODULE_3__/* ["default"].productsReady$ */ .Z.productsReady$, search$).pipe((0,rxjs_operators__WEBPACK_IMPORTED_MODULE_9__/* .skip */ .T)(1))
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductsSearchStore);

/***/ }),

/***/ 18745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IQ": function() { return /* binding */ resetDynamicObject; },
/* harmony export */   "MR": function() { return /* binding */ getUniqueValuesArray; },
/* harmony export */   "q3": function() { return /* binding */ getMapFromObjectArray; },
/* harmony export */   "t9": function() { return /* binding */ getValidObject; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getValidObject(key, value) {
  return value ? (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, value) : {};
}
function getMapFromObjectArray(array, key, value) {
  var resultObject = array.reduce(function (accumulator, currentValue) {
    var itemObject = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, currentValue[key], currentValue[value]);

    return _objectSpread(_objectSpread({}, accumulator), itemObject);
  }, {});
  return resultObject;
}
function getUniqueValuesArray(_array) {
  return (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(new Set(_array));
}
function resetDynamicObject(_object) {
  var _objectKeys = Object.keys(_object);

  if (_objectKeys.length < 1) {
    return {};
  }

  var resetObject = _objectKeys.reduce(function (accumulator, currentValue) {
    return _objectSpread(_objectSpread({}, accumulator), {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, currentValue, []));
  }, {});

  return resetObject;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  getValidObject: getValidObject
});

/***/ }),

/***/ 88154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__qYN03","primaryButton":"Buttons_primaryButton__7N3x3","brandButton":"Buttons_brandButton__cCp9d","secondaryButton":"Buttons_secondaryButton__ruBI_"};

/***/ }),

/***/ 86910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"CookieBar_bannerContainer__mAx8E","content":"CookieBar_content__eQKYY","heading":"CookieBar_heading__bDofo","textContainer":"CookieBar_textContainer__XukP4","container":"CookieBar_container__M9rZh","link":"CookieBar_link__5_SUY","btnContainer":"CookieBar_btnContainer__j5YB_"};

/***/ }),

/***/ 82052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"DownloadApp_imageContainer__wDpfq","mobileLinks":"DownloadApp_mobileLinks__7E9oF","img":"DownloadApp_img__6pKM9"};

/***/ }),

/***/ 84024:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__Vebor","appSector":"Footer_appSector__CIDTt","socialHeader":"Footer_socialHeader__ePM8w","flexCenter":"Footer_flexCenter__pNqCG","downloadAppTitle":"Footer_downloadAppTitle___Un6K"};

/***/ }),

/***/ 7236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"Newsletter_newsletter___D8Y_","newsletter-input":"Newsletter_newsletter-input__tPbSi","newsletterButton":"Newsletter_newsletterButton__0jfDt","iconNewsletter":"Newsletter_iconNewsletter__M2n1E","iconBorder":"Newsletter_iconBorder__9PEEz"};

/***/ }),

/***/ 60564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialHeader":"Social_socialHeader__NGLbI","social":"Social_social__yUJzZ","socialItem":"Social_socialItem__I7grb","socialIcon":"Social_socialIcon__GI6oW"};

/***/ }),

/***/ 36477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLinks_container__aeUSr","sector":"FooterLinks_sector__ARmy8","contactSector":"FooterLinks_contactSector__6gEEI","contactNumber":"FooterLinks_contactNumber__T_5TE","logo":"FooterLinks_logo__6RxiX","tel":"FooterLinks_tel__gg2Zr","header":"FooterLinks_header__HCTho","link":"FooterLinks_link__lAyc6","social":"FooterLinks_social__CL_Lp","contactIcon":"FooterLinks_contactIcon__vtV5g","logoContainer":"FooterLinks_logoContainer__RVW_c"};

/***/ }),

/***/ 1677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterPaymentMethods_container__9H7gk","section":"FooterPaymentMethods_section__IVxMq","credits":"FooterPaymentMethods_credits__Dy0vE","text":"FooterPaymentMethods_text__dcGGr","brand":"FooterPaymentMethods_brand__VVhJu","heartML":"FooterPaymentMethods_heartML__cA0IE","paymentMethods":"FooterPaymentMethods_paymentMethods__BaiRp","nbg":"FooterPaymentMethods_nbg__lE5RD","paymentMethodImg":"FooterPaymentMethods_paymentMethodImg__m_YKF","divider":"FooterPaymentMethods_divider__5jkTd"};

/***/ }),

/***/ 99116:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navHamburger":"Hamburger_navHamburger__OJLLl","line":"Hamburger_line__WpfWW"};

/***/ }),

/***/ 55125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__FGbDi","modalContainer":"Header_modalContainer__0qsLX","modalIcon":"Header_modalIcon__O5Tta","modalText":"Header_modalText__SsOG0","logo":"Header_logo__SAQTw","leftContainer":"Header_leftContainer__n2fCI","rightContainer":"Header_rightContainer__Eyl1F","middleContainer":"Header_middleContainer__wyQcx","subContainer":"Header_subContainer__DSYPv","middleContainerSmallScreen":"Header_middleContainerSmallScreen__xd8G3","navMenu":"Header_navMenu__UgOTz","logoContainer":"Header_logoContainer__d_9H_"};

/***/ }),

/***/ 993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cart":"HeaderCart_cart__38ykT","cartHeaderContainer":"HeaderCart_cartHeaderContainer__XR3Hs","cartContainer":"HeaderCart_cartContainer__By1A8","isFullPageCart":"HeaderCart_isFullPageCart__HsVR_","cartIconContainer":"HeaderCart_cartIconContainer__Ur8V3","icon":"HeaderCart_icon__Hdxmr","numProductsText":"HeaderCart_numProductsText___KJQv","text":"HeaderCart_text__8la__"};

/***/ }),

/***/ 6581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"user":"HeaderUser_user__gCYKi","nameText":"HeaderUser_nameText__zdvJ7","icon":"HeaderUser_icon__hcu45","iconUser":"HeaderUser_iconUser__eorhN","text":"HeaderUser_text__4KIaK"};

/***/ }),

/***/ 61680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLogo_logo__zTYp1"};

/***/ }),

/***/ 23276:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Navigation_container__983ML","shopImage":"Navigation_shopImage__jWAwJ","navbar":"Navigation_navbar__cmMsV","link":"Navigation_link__CiABP","relative":"Navigation_relative__xlZYE","submenuDropdown":"Navigation_submenuDropdown__uEiHh","submenu":"Navigation_submenu__Di7nX","subnavLink":"Navigation_subnavLink__JYSiO"};

/***/ }),

/***/ 50790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__S7U_U","input":"SearchBar_input__eMa_Q","submit":"SearchBar_submit__CkWzd","icon":"SearchBar_icon___Uf6l","searchText":"SearchBar_searchText__DJYfe","img":"SearchBar_img__43ig9"};

/***/ }),

/***/ 17659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopsLink_container__Rsgv5","text":"ShopsLink_text__MubDj","icon":"ShopsLink_icon__ceoTu"};

/***/ }),

/***/ 37973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonToTop_button__kufII","hideButton":"ButtonToTop_hideButton__RlIu4","icon":"ButtonToTop_icon__aLgpV"};

/***/ }),

/***/ 25387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"SuggestedSearchProduct_link__RIiYz","icon":"SuggestedSearchProduct_icon__7fxgk","resultTitle":"SuggestedSearchProduct_resultTitle__TXUhA","resultSubtitle":"SuggestedSearchProduct_resultSubtitle__OWmZw","productSubtitle":"SuggestedSearchProduct_productSubtitle__g_uP9","badge":"SuggestedSearchProduct_badge__CP3iu","webStickerContainer":"SuggestedSearchProduct_webStickerContainer__oQ0Sf","img":"SuggestedSearchProduct_img__TGG01","productTextsContainer":"SuggestedSearchProduct_productTextsContainer__o7LBb"};

/***/ }),

/***/ 60715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestedSearchResults_container__w7KHD","title":"SuggestedSearchResults_title__yC4Dr","link":"SuggestedSearchResults_link__kZaNj","icon":"SuggestedSearchResults_icon__RDn5C","resultTitle":"SuggestedSearchResults_resultTitle__5UMkA","resultSubtitle":"SuggestedSearchResults_resultSubtitle__3oT9Q","productSubtitle":"SuggestedSearchResults_productSubtitle__Tp8MG","badge":"SuggestedSearchResults_badge__YWnlV","webStickerContainer":"SuggestedSearchResults_webStickerContainer__KQBAa","img":"SuggestedSearchResults_img__wrV_7","productTextsContainer":"SuggestedSearchResults_productTextsContainer__9XDhN"};

/***/ })

}]);